class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
    const firstInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    const isResponsiveHeaderSearch =
      this.classList.contains('header__search') && window.matchMedia('(max-width: 989px)').matches;

    if (isResponsiveHeaderSearch) {
      const sideMenu = document.getElementById('Details-menu-drawer-container');

      if (sideMenu?.hasAttribute('open')) {
        sideMenu.removeAttribute('open');
        sideMenu.classList.remove('menu-opening');
        sideMenu.querySelectorAll('details[open]').forEach((detail) => {
          if (detail !== sideMenu) detail.removeAttribute('open');
        });
      }
    }

    trapFocus(focusContainer, isResponsiveHeaderSearch ? focusContainer : firstInput);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
